module.exports = __webpack_public_path__ + "img/20190523194840微信截图_20190523195221.acb7a01a.png";